// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import getRcAcademyLink, { xRcAcademyModel } from "@rc/App/Handlers/RcAcademy/getRcAcademyLink";
import * as React from "react";
import { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    getRcAcademyLink,
}


type Props = ResolveThunks<typeof mapDispatchToProps>;

const RcAcademyAutoRedirect: React.FunctionComponent<Props> = (props: Props) => {
    const {
        getRcAcademyLink,
    } = props;

    const toasterContext = useContext(ToasterContext);

    const getLink = () => {
        getRcAcademyLink({
            onSuccess(result) {
                openLink(result);
            },
            onError: (error: any) => {
                toasterContext.addToast({
                    body: error,
                    messageType: "danger",
                });
            },
        });
    }

    const openLink = (result: any) => {
        window.open((result as xRcAcademyModel).redirectUrl, "_blank");
    }

    React.useEffect(() => {
        getLink();
    }, []);

    return (
       <></>
    );

};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(RcAcademyAutoRedirect),
    definition: {
        group: "XNGAGE" as any,
        displayName: "RC Academy Auto Redirect",
        fieldDefinitions: [
        ],
    },
};

export default widgetModule;
